export const BASE_API_ROUTE = 'https://api.box.com/2.0';

export const GET_ITEMS_DEFAULT_LIMIT = 2000;
